import { type ClassValue, clsx } from 'clsx';
import { extendTailwindMerge } from 'tailwind-merge';

import tailwindConfig from '../../tailwind.config';

const customFontSizes = Object.keys(tailwindConfig.theme.extend.fontSize).map(String);

const twMerge = extendTailwindMerge({
    classGroups: {
        'font-size': [{ text: customFontSizes }]
    }
});

export function classNames(...inputs: ClassValue[]): string {
    return twMerge(clsx(inputs));
}
